import React, { createContext, useEffect, useState } from "react";

const ViewerContext = createContext();

export function ViewerProvider({ children }) {
  const [loadedFileDataList, setLoadedFileDataList] = useState([]);
  const [loadedFileNameList, setLoadedFileNameList] = useState([]);
  const [igcParsedData, setIgcParsedData] = useState([]);
  const [coloredFile, setColoredFile] = useState();
  const [trailDuration, setTrailDuration] = useState(80000);
  const [autoSwitchTail, setAutoSwitchTail] = useState(false);
  // Escape hatch out of the focused time window: show everything that was
  // recorded, parked logger and drive to launch included
  // (helper/contentWindow.js, timeline bar toggle).
  const [fullRange, setFullRange] = useState(false);

  return (
    <ViewerContext.Provider
      value={{
        loadedFileDataList, setLoadedFileDataList,
        loadedFileNameList, setLoadedFileNameList,
        igcParsedData, setIgcParsedData,
        coloredFile, setColoredFile,
        trailDuration, setTrailDuration,
        autoSwitchTail, setAutoSwitchTail,
        fullRange, setFullRange
      }}
    >
      {children}
    </ViewerContext.Provider>
  );
}

export default ViewerContext;
